<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="row">
  <div class="col-12">
    <app-card cardTitle="Programas Cadastrados" blockClass="table-border-style" [options]="false">
      <div class="row mb-3">
        <div class="col-12 text-right">
          <button type="button" class="btn btn-success" (click)="abrirModalNovo()">
            <i class="feather icon-plus-circle"></i> NOVO PROGRAMA
          </button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Descricão</th>
              <th>Data Inicio</th>
              <th>Data Fim</th>
              <th>Acão</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of arrayProgramas">
              <td>{{item.descricao }}</td>
              <td>{{item.datA_INICIO | date: "dd/MM/yyyy HH:mm:ss"}}</td>
              <td>{{item.datA_FIM | date: "dd/MM/yyyy HH:mm:ss"}}</td>
              <td>
                <button type="button" class="btn btn-icon btn-info " (click)="carregarEdicao(item)">
                  <i class="fa fa-edit"></i>
                </button>
                &nbsp;&nbsp;
                <button type="button" class="btn btn-icon btn-danger " (click)="desabilitar(item.id)">
                  <i class="fa fa-trash"></i>
                </button>

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </app-card>
  </div>
</div>

<!-- Modal para Cadastro/Edição de Programa -->
<app-ui-modal #modalPrograma [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h5 class="modal-title">{{ programaSelecionado != null ? 'Editar Programa' : 'Novo Programa' }}</h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="fecharModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <div class="row">
      <div class="col-sm-12 col-xl-12">
        <label class="sub-title">Nome Programa</label>
        <input type="text" class="form-control" [(ngModel)]="nome" name="nome" placeholder="">
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm-12 col-xl-6">
        <label class="sub-title">Data Inicio</label>
        <input type="date" class="form-control" [(ngModel)]="dataInicial" name="dataInicial" placeholder="">
      </div>
      <div class="col-sm-12 col-xl-6">
        <label class="sub-title">Data Fim</label>
        <input type="date" class="form-control" [(ngModel)]="dataFinal" name="dataFinal" placeholder="">
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm-12 col-xl-12">
        <label class="sub-title">Termo de Aceite</label>
        <app-tinymce [(ngModel)]="termoAceite" name="termoAceite" #tinymce='tinymce'></app-tinymce>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-secondary" (click)="fecharModal()">CANCELAR</button>
    <button type="button" class="btn btn-success" (click)="salvar()">
      SALVAR &nbsp;<i class="feather icon-check-circle"></i>
    </button>
  </div>
</app-ui-modal>
